<template>
  <div>
    <div class="position-relative">
      <!-- shape Hero -->
      <section style="margin-top:140px">
        <div class="container">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link to="/">Home</router-link>
              </li>
              <li class="breadcrumb-item">
                <router-link to="/solutions/cloud">Cloud</router-link>
              </li>
              <li class="breadcrumb-item active" aria-current="page">
                DevOps
              </li>
            </ol>
          </nav>

          <div class="row">
            <div class="col-lg-8">
              <h2 class="title">DevOps</h2>

              <h3 class="title  pt-2"></h3>
              <p class="lead">
                To leverage on the era of digital transformation, we see big companies and corporations make a shift on how they build, test, and deploy their solutions and applications. With the drive towards virtualization and other technology innovations, companies that can leverage these trends, drive organizational change and deliver value in an agile and timely way will gain competitive advantage. They must utilize IT talent to its fullest potential as it evolves in response to the DevOps phenomenon. One of the problems encountered is developing a strategy that unites different teams together and creates automation and processes that allow them to leverage new technologies at speed .
              </p>
              <p class="lead">
                Our Development Operations (DevOps) practice educates organizations in DevOps philosophy and best practices; shifts technology, culture and process, and facilitates the supporting development infrastructure and strategy. Using our DevOps methodology, the client can streamline teams, speed development, increase agility, and accelerate software releases.
              </p>

              <p class="lead">
               While working with our clients to develop their DevOps practice, we help them create a cultural shift towards collaboration. Also, we focus on building the infrastructure to automate all steps of the development lifecycle from inception, development of code, testing, quality assurance, staging and production. This speeds development and sharing of new features and capabilities to drive releases to market as quickly as possible. We additionally offer support through vendor solutions that fit an organization’s development stream and aid in automation efforts. We can help clients open and operate their DevOps tools and release software rapidly, frequently and reliably.
              </p>

          
            </div>

            <div class="col-lg-4">
              <CloudSideNav></CloudSideNav>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>
<script>
import CloudSideNav from "./CloudSideNav";
export default {
  name: "cloud overview",
  components: {
    CloudSideNav,
  },
};
</script>
<style>
.shape-container {
  padding-bottom: 5rem;
}
</style>
